var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.659363 1.80125C0.659363 0.806874 1.46624 0 2.46061 0C3.45436 0 4.26123 0.806874 4.26186 1.80125C4.26186 2.79562 3.45498 3.61937 2.46061 3.61937C1.46624 3.61937 0.659363 2.79562 0.659363 1.80125ZM15.6556 14.9999L15.6593 14.9993V9.49807C15.6593 6.80682 15.08 4.7337 11.9337 4.7337C10.4212 4.7337 9.40623 5.5637 8.99185 6.35057H8.9481V4.98495H5.96498V14.9993H9.07123V10.0406C9.07123 8.73495 9.31873 7.47245 10.9356 7.47245C12.5287 7.47245 12.5525 8.96244 12.5525 10.1243V14.9999H15.6556ZM0.906837 4.98568H4.01683V15H0.906837V4.98568Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInFoot);
export default __webpack_public_path__ + "static/media/in-foot.c6253473fdd4c84858f46cfe139fcc3f.svg";
export { ForwardRef as ReactComponent };